import { render, staticRenderFns } from "./NotAuthorized.vue?vue&type=template&id=e42f1f9c&scoped=true&"
import script from "./NotAuthorized.vue?vue&type=script&lang=ts&"
export * from "./NotAuthorized.vue?vue&type=script&lang=ts&"
import style0 from "./NotAuthorized.vue?vue&type=style&index=0&id=e42f1f9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42f1f9c",
  null
  
)

export default component.exports